const normalizeLoadingPhaseText = (value = "") =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

const LOADING_PHASE_GROUPS = [
  {
    kind: "search",
    category: null,
    patterns: [
      /^search(?:ing)? (?:the )?(?:internet|web)\b/i,
      /\binternet search\b/i,
      /\bweb search\b/i,
      /\bsearch the web\b/i,
      /\blive sources\b/i,
      /\bsource lookup\b/i,
      /\bcitations?\b/i,
    ],
  },
  {
    kind: "analysis",
    category: "response",
    patterns: [
      /^planning market analysis\b/i,
      /^decision map ready\b/i,
      /^layered analysis skipped\b/i,
      /^building evidence packet\b/i,
      /^evidence packet ready\b/i,
      /^resolving direct data\b/i,
      /^direct data attached\b/i,
      /^running specialist layers\b/i,
      /^specialists complete\b/i,
      /^(?:price action|fundamentals|catalysts|peer and sector|risk|macro|options) (?:running|complete|unavailable)\b/i,
      /^resolving final view\b/i,
      /^recommendation formed\b/i,
      /^quality check\b/i,
      /^writing final answer\b/i,
      /^final answer delivered\b/i,
      /^data freshness note\b/i,
    ],
  },
  {
    kind: "tickers",
    category: "tickers",
    patterns: [
      /^(?:pulling|fetching|loading|retrieving|syncing|scanning|evaluating|preparing)\s+your watchlist (?:tickers|symbols)\b/i,
      /^adding tickers to watchlist\b/i,
    ],
  },
  {
    kind: "pricing",
    category: "pricing",
    patterns: [
      /^(?:focusing on time scales|focusing on trading horizon|setting analysis timeframe|selecting trading scale|targeting analysis window|adjusting time horizon|locking analysis scale|calibrating trading horizon|narrowing timeframe|applying time-scale focus|pivoting to time horizon)\b/i,
      /^(?:updating|refreshing|syncing|aggregating|fetching)\s+(?:pricing data|price data|latest prices|price updates|quotes?|quote feed)\b/i,
      /^(?:assessing|selecting|screening|evaluating|ranking|preparing)\s+tickers?\b.*\b(?:charting|charts?|visualization|chart view)\b/i,
      /^(?:pulling|fetching|loading|retrieving|updating|syncing)\s+(?:chart data|historical data|chart series|time series|chart cache|price history)\b/i,
    ],
  },
  {
    kind: "stats",
    category: "stats",
    patterns: [
      /^(?:updating|updated|refreshed|calculated)\b.*\b(?:market statistics|market stats|market metrics|metrics|market data summary)\b/i,
    ],
  },
  {
    kind: "reports",
    category: "reports",
    patterns: [
      /^(?:checking|looking for|scanning|checking latest|reviewing|searching for|polling)\b.*\b(?:sec|filings?|reports?|submissions?)\b/i,
    ],
  },
  {
    kind: "criteria",
    category: "criteria",
    patterns: [
      /^(?:engaging|applying|running|activating|executing|filtering)\b.*\b(?:advanced filtering criteria|advanced filter pass|filters?|screening|criteria based filtering)\b/i,
      /^(?:parsing|interpreting|evaluating|analyzing|reading|expanding|loading)\b.*\b(?:criteria|rules|configuration|constraints)\b/i,
      /^engaging options query\b/i,
    ],
  },
  {
    kind: "markets",
    category: "markets",
    patterns: [
      /^(?:pulling|updating|refreshing|fetching|aggregating|streaming|syncing|retrieving)\s+market indices\b/i,
      /^(?:(?:wide )?query\s+)?(?:identified|detected|resolved|matched)\s+(?:exchanges|countries|trading venues|listing countries)\b/i,
    ],
  },
  {
    kind: "memory",
    category: "memory",
    patterns: [
      /^(?:updating|saving|recording|persisting|storing|committing)\b.*\bmemory\b/i,
    ],
  },
  {
    kind: "response",
    category: "response",
    patterns: [
      /^now aggregating all data for analysis\b/i,
      /^(?:generating|preparing|finalizing|initiating|constructing|creating|assembling|composing|starting|beginning|launching|booting|processing|synthesizing|now preparing)\b.*\b(?:response|reply|output)\b/i,
      /^(?:generating|preparing|finalizing|initiating|constructing|creating|assembling|composing|starting)\s+(?:pdf|docx|csv|xlsx)\b/i,
      /^(?:finished|complete|process complete|all tasks complete|done|completed)\b/i,
    ],
  },
];

export const getLoadingPhaseGroup = (value = "") => {
  const normalized = normalizeLoadingPhaseText(value);
  if (!normalized) return null;

  return LOADING_PHASE_GROUPS.find((group) =>
    group.patterns.some((pattern) => pattern.test(normalized)),
  ) || null;
};

export const getLoadingPhaseKind = (value = "") =>
  getLoadingPhaseGroup(value)?.kind || "default";

export const getLoadingPhaseCategory = (value = "") =>
  getLoadingPhaseGroup(value)?.category || null;

export const isInternetSearchPhase = (value = "") =>
  getLoadingPhaseKind(value) === "search";

export { normalizeLoadingPhaseText };
